import { render, staticRenderFns } from "./PillVertical.vue?vue&type=template&id=0ae0e9ff&"
import script from "./PillVertical.vue?vue&type=script&lang=js&"
export * from "./PillVertical.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports